import { ACTION_TYPES } from '../constants';

const dashboardsLoadingReducer = (state = true, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_DASHBOARDS_BY_WORKSPACE_REQUEST:
      return true;
    case ACTION_TYPES.GET_DASHBOARDS_BY_WORKSPACE_SUCCESS:
    case ACTION_TYPES.GET_DASHBOARDS_BY_WORKSPACE_FAILURE:
      return false;
    default: {
      return state;
    }
  }
};

export default dashboardsLoadingReducer;
